import React from 'react';
import styled from 'styled-components';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { GqlMobileCustomization } from 'types/graphql';
import { AccountIcon, CartIcon, PayIcon, ShopFilledIcon, SpecialsIcon } from './mobile-tab-icons';

type TabIconProps = {
  color?: string;
  icon: JSX.Element;
  label: string;
};

const TabIcon = ({ color, icon, label }: TabIconProps): JSX.Element => (
  <TabIconContainer color={color}>
    {icon}
    {label}
  </TabIconContainer>
);

const valueOrDefault = (value: string | null | undefined, defaultValue: string): string =>
  value?.length ? value : defaultValue;

const TabBar = ({ mobileCustomization }: { mobileCustomization?: GqlMobileCustomization | null }): JSX.Element => {
  const flags = useFlags();
  const showPay = flags['fintech.retail-payments.scan-to-pay.rollout'] ?? false;

  return (
    <TabBarContainer
      backgroundColor={valueOrDefault(mobileCustomization?.bottomBarBackgroundColor, '#FFFFFF')}
      color={valueOrDefault(mobileCustomization?.bottomBarInactiveColor, '#4F5D68')}
    >
      <TabIcon
        color={valueOrDefault(mobileCustomization?.bottomBarActiveColor, '#0B99E6')}
        icon={<ShopFilledIcon />}
        label={valueOrDefault(mobileCustomization?.tabLabels?.shop, 'Shop')}
      />
      <TabIcon icon={<SpecialsIcon />} label={valueOrDefault(mobileCustomization?.tabLabels?.specials, 'Specials')} />
      <TabIcon icon={<CartIcon />} label={valueOrDefault(mobileCustomization?.tabLabels?.cart, 'Cart')} />
      {showPay && <TabIcon icon={<PayIcon />} label={valueOrDefault(mobileCustomization?.tabLabels?.pay, 'Pay')} />}
      <TabIcon icon={<AccountIcon />} label={valueOrDefault(mobileCustomization?.tabLabels?.account, 'Account')} />
    </TabBarContainer>
  );
};

const TabBarContainer = styled.div<{ backgroundColor: string; color: string }>`
  background-color: ${({ backgroundColor }) => backgroundColor};
  color: ${({ color }) => color};
  display: flex;
  justify-content: space-between;
  padding: 8px 20px 50px;
  width: 100%;
`;

const TabIconContainer = styled.div<{ color?: string }>`
  align-items: center;
  color: ${({ color }) => (color?.length ? color : 'inherit')};
  display: flex;
  flex-direction: column;
  font-weight: ${({ color }) => (color ? 'bold' : 'normal')};
  justify-content: center;

  > svg {
    margin-bottom: 3px;
  }
`;

export default TabBar;
